import { render, staticRenderFns } from "./FormStep2.vue?vue&type=template&id=2bfbe2ca"
import script from "./FormStep2.vue?vue&type=script&lang=js"
export * from "./FormStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports